import Vue from 'vue'
import moment from 'moment'
moment.locale('id')
Vue.filter('parse', (value, id) => {
  if (id === null || id === undefined) return value
  if (value === null || value === undefined) return value
  let toReturn = ''
  if (id.search('-') === -1) {
    switch (id) {
      case 'active':
        toReturn = value === 1 ? 'Data Aktif' : 'Non Aktif'
        break
      case 'status_overall':
        toReturn = value ? 'Selesai' : 'Belum Selesai'
        break
      case 'calculated':
        toReturn = value === 'calculated' ? 'Sudah Dihitung' : 'Belum Dihitung'
        break
      case 'active-member':
        toReturn = value === 1 ? 'Anggota Aktif' : 'Non Aktif'
        break
      case 'charge':
        toReturn = value === 'companies' ? 'Perusahaan' : 'Tenaga Kerja'
        break
      case 'valsal':
        toReturn = value === 'valsal' ? 'Vendor/Subkon' : 'Kontraktor'
        break
      case 'uppercase':
        toReturn = value.toUpperCase()
        break
      case 'allow':
        toReturn = value.toLowerCase() === 'y' ? 'DIperbolehkan' : 'Tidak diizinkan'
        break
      case 'lock':
        toReturn = value.toLowerCase() === 'y' ? 'Close' : 'Open'
        break
      case 'yn':
        toReturn = value.toLowerCase() === 'y' ? 'Ya' : 'Tidak'
        break
      case 'ynBool':
        toReturn = value ? 'Ya' : 'Tidak'
        break
      case 'prosen':
        toReturn = Number(value).toLocaleString('id-ID') + '%'
        break
      case 's_komponen':
        toReturn = value + ' Komponen'
        break
      case 'count_day_of_work':
        toReturn = value + ' Hari Kerja'
        break
      case 'verify':
        if (value === 'revision_request') toReturn = 'Permintaan Revisi'
        else if (value === 'verification_request') toReturn = 'Pengajuan Verifikasi'
        else if (value === 'appraisal_request') toReturn = 'Permintaan Penilaian'
        else if (value === 'approved') toReturn = 'Disetujui'
        else toReturn = 'Draft'
        break
      case 'modules':
        if (value === 'customer_complaints') toReturn = 'Keluhan Pelanggan'
        else if (value === 'kkkl_daily_reports') toReturn = 'K3L Daily'
        else if (value === 'mm_appraisals') toReturn = 'SMM'
        else if (value === 'qhse_daily_activities') toReturn = 'Daily Activity'
        else if (value === 'qhse_nc_qa') toReturn = 'Non Conformance'
        else if (value === 'qpass_appraisals') toReturn = 'QPASS'
        else if (value === 'smkkkl_appraisals') toReturn = 'SMK3L'
        else if (value === 'r_appraisals') toReturn = '5R'
        else if (value === 'qhse_nc_hse') toReturn = 'HSE NC'
        else if (value === 'kkkl_accident_cause_analysis') toReturn = 'Analisa Penyebab'
        else if (value === 'kkkl_occupt_diss_accidents') toReturn = 'Kecelakaan / Penyakit Akibat Kerja'
        else if (value === 'kkkl_critical_plans') toReturn = 'Rencana Tugas Kritikal'
        else if (value === 'kkkl_onsite_kkkl_personnels') toReturn = 'Tenaga K3L On Site'
        else if (value === 'kkkl_trainings') toReturn = 'Pelatihan K3L'
        else if (value === 'users_verifications') toReturn = 'Verifikasi Pendaftaran'
        else toReturn = 'Unknown'
        break
      case 'number':
        toReturn = !isNaN(value) ? Number(value).toLocaleString('id') : value
        break
      case 'number2fraction':
        toReturn = !isNaN(value) ? Number(value).toLocaleString('id', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value
        break
      case 'money':
        toReturn = !isNaN(value) ? 'Rp. ' + Number(value).toLocaleString('id') : value
        break
      case 'longDate':
        if (moment(value, 'YYYY-MM-DD', true).isValid()) toReturn = moment(value).format('LL')
        else toReturn = value
        break
      case 'longDateTime':
        toReturn = moment(value).format('LLLL')
        break
      case 'period':
        if (moment(value, 'YYYY-MM-DD', true).isValid()) toReturn = moment(value).format('MMMM YYYY')
        else toReturn = value
        break
      case 'year':
        if (moment(value, 'YYYY-MM-DD', true).isValid()) toReturn = moment(value).format('YYYY')
        else toReturn = value
        break
      case 'hours':
        let parsed = value.split(':')
        parsed[0] = (Number(parsed[0]) > 0) ? Number(parsed[0]) + ' Jam' : null
        parsed[1] = (Number(parsed[1]) > 0) ? Number(parsed[1]) + ' Menit' : null
        parsed[2] = (Number(parsed[2]) > 0) ? Number(parsed[2]) + ' Detik' : null
        toReturn = parsed.filter(x => x).join(', ')
        break
      case 'time':
        toReturn = moment(value, 'HH:mm:ss').format('LTS a')
        break
      case 'kelamin':
        toReturn = value.toLowerCase() === 'male' ? 'Laki-Laki' : 'Perempuan'
        break
      case 'kawin':
        if (value === 'single') toReturn = 'Belum Menikah'
        else if (value === 'married') toReturn = 'Menikah'
        else if (value === 'widow') toReturn = 'Janda/Duda'
        else toReturn = 'Tidak Diketahui'
        break
      case 'status_code':
        toReturn = value.toLowerCase().split('_').map((kebab) => kebab.toLowerCase().charAt(0).toUpperCase() + kebab.slice(1)).join(' ')
        break
      case 'qa_criteria':
        toReturn = value.toLowerCase() === 'hse' ? 'HSE' : 'Quality'
        break
      case 'handling_category':
        if (value === 'corporate') toReturn = 'Corporate'
        else if (value === 'department') toReturn = 'Departemen'
        else toReturn = 'Proyek'
        break
      case 'risk_level':
        if (value === 1) toReturn = 'Rendah'
        else if (value === 2) toReturn = 'Sedang'
        else toReturn = 'Tinggi'
        break
      case 'single_number_type':
        if (value === 'smk3l') toReturn = 'SMK3L'
        else if (value === 'mm') toReturn = 'Manajemen Mutu'
        else toReturn = 'Penilaian 5R'
        break
      case 'is_structural':
        toReturn = value ? 'Jabatan Struktural' : 'Jabatan non Struktural'
        break
      case 'is_plt':
        toReturn = value === true ? 'PLT' : 'Non PLT'
        break
      case 'is_mpp':
        toReturn = value === true ? 'MPP' : 'Non MPP'
        break
      case 'sync':
        toReturn = value === 'not_synchronized_yet' ? 'Belum di Sinkronkan' : 'Sudah di Sinkronkan'
        break
      case 'holiday':
        toReturn = value === 'holiday' ? 'Hari Libur' : 'Hari Kerja'
        break
      case 'is_kiw':
        toReturn = value === 'kiw' ? 'KIW' : 'Eksternal'
        break
      case 'finished':
        toReturn = value === 'finished' ? 'Sudah Selesai' : 'Belum Selesai'
        break
      default:
        toReturn = value
    }
  } else {
    switch (id.split('-')[0]) {
      case 'prefix':
        toReturn = id.split('-')[1] + ' ' + value
        break
      case 'suffix':
        toReturn = value + ' ' + id.split('-')[1]
        break
      default:
        toReturn = value
    }
  }
  return toReturn
})
export default {
  name: 'filterTemplate'
}



// WEBPACK FOOTER //
// ./src/utils/filter.js